import React from "react"
import Link from "next/link"
import { Moon, Sun } from "lucide-react"
import { TurkwiseAuthShell, TurkwiseButton } from "@turkwise/design-system"
import { useThemeToggle } from "@/hooks/useThemeToggle"
import { AuthLayoutProps } from "@/components/AuthLayoutProps"
import { useTranslations } from "next-intl"

export const AuthLayoutBase: React.FC<AuthLayoutProps> = ({
  children,
  titleKey,
  title,
  subtitleKey,
  subtitle,
  footerTextKey,
  footerLink,
}) => {
  const { isDark, mounted, handleThemeToggle } = useThemeToggle()
  const t = useTranslations()
  const resolvedTitle = title ?? (titleKey ? t(titleKey) : "")
  const resolvedSubtitle = subtitle ?? (subtitleKey ? t(subtitleKey) : undefined)

  const footer = footerTextKey ? (
    <>
      {t(footerTextKey)}{" "}
      {footerLink ? <Link href={footerLink.href}>{t(footerLink.textKey)}</Link> : null}
    </>
  ) : null

  return (
    <TurkwiseAuthShell
      brand={{
        productName: "",
        wordmarkLightSrc: "/brand/turkwise-wordmark-light.png",
        wordmarkDarkSrc: "/brand/turkwise-wordmark-dark.png",
        monogramSrc: "/apple-icon.png",
      }}
      brandHref="/login"
      title={resolvedTitle}
      subtitle={resolvedSubtitle}
      toolbar={mounted ? (
          <TurkwiseButton
            type="button"
            shape="circle"
            size="sm"
            variant="ghost"
            onClick={handleThemeToggle}
            aria-label={isDark ? "Açık temaya geç" : "Koyu temaya geç"}
            icon={isDark ? <Sun size={18} /> : <Moon size={18} />}
          />
      ) : undefined}
      footer={footer}
    >
      {children}
    </TurkwiseAuthShell>
  )
}

export default AuthLayoutBase
